<template>
  <div class="main-wrap">

    <div class="row-item">
      <!-- 新品体验 -->
      <div class="product-wrap">
        <CardDesc></CardDesc>
        <Card
          :title-img="oneItem.titleImg"
          :desc="oneItem.desc"
          :cover="oneItem.cover"
          :link="oneItem.link"
        ></Card>
      </div>
      <Solid></Solid>
    </div>

    <div class="row-item">
        <div class="product-wrap">
            <Card
              v-for="item in itemData1"
              :key="index"
              :title-img="item.titleImg"
              :desc="item.desc"
              :cover="item.cover"
              :link="item.link"
            ></Card>
        </div>
        <Solid></Solid>
    </div>

    <div class="row-item">
      <div class="product-wrap">
        <Card
          v-for="item in itemData2"
          :key="index"
          :title-img="item.titleImg"
          :desc="item.desc"
          :cover="item.cover"
          :link="item.link"
        ></Card>
      </div>
    </div>

  </div>
</template>

<script>
// import Swiper from 'swiper';

import vTitle from "../components/title.vue";
import Card from "./card.vue"
import CardDesc from "./cardDesc.vue"
import Solid from "./solid.vue"

export default {
  name: "Index",
  components: {
    vTitle,
    Card,
    Solid,
    CardDesc
  },
  data() {
    return {

      oneItem:  {
        id: 1,
        titleImg: "qs_wf.png",
        desc: '信号强劲无死角，全屋Wi-Fi路由重磅推荐，完美应付任何家庭场景！',
        cover: 'https://s2.jiguo.com/df7bfdc6d1df0b221f7ee52b6f812c3879d0b6b8',
        link: "http://www.jiguo.com/article/article/111957.html"
      },
      itemData1: [
        {
          id: 2,
          titleImg: "ss_cy.png",
          desc: '2023年最新随身WiFi推荐，流量无烦恼、露营出游也有高速网络！',
          cover: 'http://s2.jiguo.com/cbdd44b37288505aa31d21a9abd5e98814e1dae8',
          link: "http://www.jiguo.com/article/article/111956.html"
        },
        {
          id: 3,
          titleImg: "dj_yx.png",
          desc: '电竞路由如何选？有钱也别交智商税，这两款真是太稳了',
          cover: 'http://s2.jiguo.com/9faca0cb4ec0562ca871617ac061222a4ee08f22',
          link: "http://www.jiguo.com/article/article/111951.html"
        },
      ],
      itemData2: [
        {
          id: 4,
          titleImg: "wf_6.png",
          desc: '千兆宽带还是卡？平价WIFI6路由器推荐，这一波儿不亏',
          cover: 'http://s2.jiguo.com/f79a61be31839db1868c60467768282a92f7f901',
          link: "http://www.jiguo.com/article/article/111950.html"
        },
        {
          id: 5,
          titleImg: "xqt.png",
          desc: '好看又实用！这波新奇数码好物，每一款都让人爱不释手',
          cover: 'http://s2.jiguo.com/c8df686a77f7ea8784edec79e3f1aec6778ce84f',
          link: "http://www.jiguo.com/article/article/111961.html"
        },
      ],
    }
  }
};
</script>

<style lang="scss" scoped>
img{
  object-fit: cover;
}
.main-wrap{
  margin: 0 auto;
  padding-bottom: 20px;
  width: 1080px;
  height: 100%;
  //background-color: rgba(255,196,196, 0.2);
  text-align: justify;

  .product-wrap{
    padding: 0 162px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-content: flex-start;
    .item:last-child{

    }
  }

}

.swiper{
  height:100px;
}
</style>